import ToolbarButton from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarButton';

const Bold = () => (
  <ToolbarButton
    className="ql-bold"
    text={__('Bold')}
    iconName="bold"
    dataTestId="toolbar-bold"
  />
);

export default Bold;
